import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { isAuthenticated, userRole } from '../Utils/Auth'
const SellerRoutes = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            const isRootPath = props.location.pathname === '/'

            if (isRootPath && (userRole() == 1 || !isAuthenticated())) {
                return <Component {...props} />
            }

            if (isAuthenticated() && userRole() == 1) {
                return <Component {...props} />
            } else if (userRole() == 4) {
                return (
                    <Redirect
                        to={{
                            pathname: '/dashboard/ambassador/mylots',
                            state: { from: props.location },
                        }}
                    />
                )
            } else if (userRole() == 0) {
                return <Redirect to={{ pathname: '/home', state: { from: props.location } }} />
            } else {
                return <Redirect to={{ pathname: '/', state: { from: props.location } }} />
            }
        }}
    />
)

export default SellerRoutes
